import { List } from '@epicuro-next/models/engagement';
import { createSelector } from '@ngrx/store';

import { selectAllProductLists } from './product-lists.selectors';

export const selectActiveList = createSelector(
  selectAllProductLists,
  (lists: List[]) => lists?.find((item) => item.isActive),
);

export const selectActiveListId = createSelector(
  selectActiveList,
  (list: List) => list?.id,
);

export const selectActiveListProductsReference = createSelector(
  selectActiveList,
  (list: List) => list?.productsReference,
);
